import { Filter } from "../services/swagger";

export function filtersToParamString(filters: Filter[]) {
  return objectToParamString(
    filters.filter((filter) => filter.value || filter.value === false)
  );
}

export function objectToParamString(object: any) {
  return btoa(encodeURIComponent(JSON.stringify(object)));
}

export function paramStringToObject(string: string) {
  return JSON.parse(decodeURIComponent(atob(string)));
}
